import { useContext } from "react";
import { DealerContext } from "../context";

export const useDealer = () => useContext(DealerContext);
